import { api } from '../api';

import { User } from '@/types';

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMe: builder.query<User, void>({
      query: () => ({
        url: '/v2/auth/me',
      }),
      providesTags: ['User'],
    }),

    // Отправка кода для восстановления пароля
    sendForgotPasswordCode: builder.mutation<void, { data: { email: string } }>({
      query: ({ data }) => ({
        url: '/v2/auth/forgot-password/send-code',
        method: 'POST',
        body: data,
      }),
    }),

    // Верификация кода восстановления пароля
    verifyForgotPasswordCode: builder.mutation<
      { reset_token: string },
      { data: { email: string; code: string } }
    >({
      query: ({ data }) => ({
        url: '/v2/auth/forgot-password/verify-code',
        method: 'POST',
        body: data,
      }),
    }),

    // Сброс пароля
    resetForgotPassword: builder.mutation<
      void,
      { data: { reset_token: string; new_password: string; confirm_password: string } }
    >({
      query: ({ data }) => ({
        url: '/v2/auth/forgot-password/reset-password',
        method: 'POST',
        body: data,
      }),
    }),

    // Смена пароля (для авторизованных пользователей)
    changePassword: builder.mutation<
      void,
      { data: { new_password: string; confirm_password: string } }
    >({
      query: ({ data }) => ({
        url: '/v2/auth/change-password',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetMeQuery,
  useSendForgotPasswordCodeMutation,
  useVerifyForgotPasswordCodeMutation,
  useResetForgotPasswordMutation,
  useChangePasswordMutation,
} = authApi;
